<template>
  <div class="tw:flex tw:flex-col tw:bg-blue-100 tw:rounded-xl tw:md:w-1/3 tw:p-3 tw:gap-y-2">
    <img :src="icon" :alt="productName" class="tw:h-6 tw:w-6" />
    <p class="tw:flex-grow">{{ $t(text) }}</p>
    <router-link :to="url" @click="handleEvent">
      <p class="tw:font-bold tw:text-sm tw:text-blue-700 tw:hover:underline">{{ $t(buttonLabel) }}</p>
    </router-link>
  </div>
</template>
<script setup>
import { selectedAccommodationId } from '@/layouts/queries'

import appAnalytics from '@/utils/tracking'

const props = defineProps({
  icon: Object,
  text: String,
  buttonLabel: String,
  url: String,
  productName: String,
  eventName: String,
})

const handleEvent = () => {
  appAnalytics.track(props.eventName, { accommodationId: selectedAccommodationId.value })
}
</script>
